import { render, staticRenderFns } from "./HomeSetting.vue?vue&type=template&id=3573362e&scoped=true"
import script from "./HomeSetting.vue?vue&type=script&lang=js"
export * from "./HomeSetting.vue?vue&type=script&lang=js"
import style0 from "./HomeSetting.vue?vue&type=style&index=0&id=3573362e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573362e",
  null
  
)

export default component.exports